import { render, staticRenderFns } from "./head.vue?vue&type=template&id=b837fb7e&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&lang=less&"
import style1 from "./head.vue?vue&type=style&index=1&id=b837fb7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837fb7e",
  null
  
)

export default component.exports